var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { ActionSheet, ActionSheetFooter, ActionSheetHeader } from '@progress/kendo-react-layout';
import { xIcon } from '@progress/kendo-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
/** @hidden */
var MOBILE_SMALL_DEVISE = 500;
/** @hidden */
export var AdaptiveMode = function AdaptiveMode(props) {
  var footer = props.footer,
    children = props.children,
    _a = props.windowWidth,
    windowWidth = _a === void 0 ? 0 : _a,
    navigatable = props.navigatable,
    navigatableElements = props.navigatableElements,
    expand = props.expand,
    animation = props.animation,
    onClose = props.onClose,
    adaptiveTitle = props.adaptiveTitle,
    mobileFilter = props.mobileFilter;
  var defaultProps = {
    navigatable: navigatable || false,
    navigatableElements: navigatableElements || [],
    expand: expand,
    animation: animation === false ? false : true,
    onClose: onClose,
    animationStyles: windowWidth <= MOBILE_SMALL_DEVISE ? {
      top: 0,
      width: '100%',
      height: '100%'
    } : undefined,
    className: windowWidth <= MOBILE_SMALL_DEVISE ? 'k-adaptive-actionsheet k-actionsheet-fullscreen' : 'k-adaptive-actionsheet k-actionsheet-bottom'
  };
  return /*#__PURE__*/React.createElement(ActionSheet, __assign({}, defaultProps), /*#__PURE__*/React.createElement(ActionSheetHeader, {
    className: 'k-text-center'
  }, /*#__PURE__*/React.createElement("div", {
    className: "k-actionsheet-titlebar-group k-hbox"
  }, /*#__PURE__*/React.createElement("div", {
    className: "k-actionsheet-title"
  }, /*#__PURE__*/React.createElement("div", null, adaptiveTitle)), /*#__PURE__*/React.createElement("div", {
    className: "k-actionsheet-actions"
  }, /*#__PURE__*/React.createElement(Button, {
    tabIndex: 0,
    "aria-label": "Cancel",
    "aria-disabled": "false",
    type: "button",
    fillMode: "flat",
    icon: 'x',
    svgIcon: xIcon,
    onClick: onClose
  }))), mobileFilter && /*#__PURE__*/React.createElement("div", {
    className: "k-actionsheet-titlebar-group k-actionsheet-filter"
  }, mobileFilter)), children, footer && /*#__PURE__*/React.createElement(ActionSheetFooter, {
    className: 'k-actions k-actions-stretched'
  }, /*#__PURE__*/React.createElement(Button, {
    size: "large",
    tabIndex: 0,
    "aria-label": footer.cancelText,
    "aria-disabled": "false",
    type: "button",
    onClick: footer.onCancel
  }, footer.cancelText), /*#__PURE__*/React.createElement(Button, {
    tabIndex: 0,
    themeColor: "primary",
    size: "large",
    "aria-label": footer.applyText,
    "aria-disabled": "false",
    type: "button",
    onClick: footer.onApply
  }, footer.applyText)));
};